import React, { useState, lazy } from 'react';
import { ScrollSection } from '../components/About/ScrollSection';
import { Tabs, TabList, Tab, TabPanel } from '../components/UI/Tabs';
export const About = () => {
  const [activeTab, setActiveTab] = useState('vision');
  return <div className="pt-20" data-id="element-1057">
      <section className="py-16 bg-secondary/5" data-id="element-1058">
        <div className="container mx-auto px-4" data-id="element-1059">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-secondary-dark mb-8" data-id="element-1060">
            About The Networking Salon
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-1061">
            Building communities that connect professionals to powerful
            networks, transformative ideas, and life-changing opportunities.
          </p>
        </div>
      </section>
      <div className="container mx-auto px-4 py-16" data-id="element-1062">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1063">
          <div className="order-2 lg:order-1" data-id="element-1064">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pmaGVbLENs5yRHebja1Kb2/3_Bibi.jpg" alt="Diverse people networking at The Networking Salon" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1065" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-1066">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1067">
              About Us
            </h2>
            <p className="text-secondary text-lg" data-id="element-1068">
              The Networking Salon is a global initiative designed to connect
              young professionals, coaches, mentors, business leaders,
              executives, and social impact drivers (ages 18–45) across 30
              cities worldwide. We build close-knit, high-value communities that
              connect people to powerful networks, transformative ideas, and
              accessible opportunities that help them thrive in their careers,
              businesses, and impact initiatives.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1069">
          <div data-id="element-1070">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1071">
              Why We Exist
            </h2>
            <p className="text-secondary text-lg" data-id="element-1072">
              Today's professionals face increasing isolation, fragmented
              networks, and limited access to life-changing opportunities. In
              many cities, young changemakers and professionals lack trusted
              communities where they can find both strategic connections and
              meaningful collaboration. Without intentional networking
              platforms, talent and ideas remain siloed. Promising leaders are
              left without the visibility, opportunities, or relationships they
              need to grow and scale their work.
            </p>
          </div>
          <div data-id="element-1073">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3oN7mV8GW4b1q39kgBjUNn/1755202597036.jpg" alt="Professionals facing isolation and fragmented networks" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1074" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1075">
          <div className="order-2 lg:order-1" data-id="element-1076">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cMappWzpJqsfBegZChWrww/1755202597051.jpg" alt="Salon-style gatherings and collaborative sessions" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1077" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-1078">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1079">
              Our Solution
            </h2>
            <p className="text-secondary text-lg" data-id="element-1080">
              The Networking Salon is more than a meetup — it's a vibrant,
              human-centered community. Through salon-style gatherings,
              mastermind sessions, micro-events, and digital collaboration
              spaces, members build trusted relationships, gain visibility,
              access curated opportunities (grants, fellowships, speaking
              engagements, career openings), exchange powerful ideas, and unlock
              their potential in a dynamic, supportive environment.
            </p>
            <p className="text-secondary text-lg mt-4" data-id="element-1081">
              We've designed The Networking Salon as a layered ecosystem—free at
              the edges, valuable at the core, and transformative at the summit.
              Each level is a step closer to intentional growth, meaningful
              connection, and collaborative impact.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1082">
          <div data-id="element-1083">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1084">
              Community Structure
            </h2>
            <div className="space-y-4" data-id="element-1085">
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1086">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1087">
                  The Waiting Room
                </h3>
                <p className="text-gray-600" data-id="element-1088">
                  An open, welcoming space for curious minds and aspiring
                  community members, providing free entry into our digital
                  ecosystem.
                </p>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1089">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1090">
                  Event Pathway
                </h3>
                <p className="text-gray-600" data-id="element-1091">
                  Paid access through in-person participation, ideal for
                  professionals who thrive in face-to-face environments.
                </p>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1092">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1093">
                  Inner Circle
                </h3>
                <p className="text-gray-600" data-id="element-1094">
                  Full community membership with access to masterclasses,
                  resources, and networking with coaches and business leaders.
                </p>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1095">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1096">
                  Lifetime Partner Access
                </h3>
                <p className="text-gray-600" data-id="element-1097">
                  Strategic & personalized growth for entrepreneurs seeking deep
                  transformation and tailored support.
                </p>
              </div>
            </div>
          </div>
          <div data-id="element-1098">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="The Networking Salon community structure" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1099" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" id="vision-mission-values" data-id="element-1100">
          <div data-id="element-1101">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1102">
              Our Vision, Mission & Core Values
            </h2>
            <div data-id="element-1103">
              <Tabs defaultTab="vision" className="mt-4" data-id="element-1104">
                <TabList data-id="element-1105">
                  <Tab id="vision" data-id="element-1106">Vision</Tab>
                  <Tab id="mission" data-id="element-1107">Mission</Tab>
                  <Tab id="values" data-id="element-1108">Values</Tab>
                </TabList>
                <TabPanel id="vision" data-id="element-1109">
                  <div className="p-4 border border-gray-200 rounded-lg mt-4" data-id="element-1110">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1111">Our Vision</h3>
                    <p data-id="element-1112">
                      A world where every young professional and changemaker has
                      access to powerful networks, transformative ideas, and
                      life-changing opportunities — regardless of where they
                      start.
                    </p>
                  </div>
                </TabPanel>
                <TabPanel id="mission" data-id="element-1113">
                  <div className="p-4 border border-gray-200 rounded-lg mt-4" data-id="element-1114">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1115">Our Mission</h3>
                    <p data-id="element-1116">
                      To build thriving, close-knit communities across 30 cities
                      by 2030 that connect professionals, mentors, and leaders
                      to people, ideas, and opportunities that help them grow,
                      lead, and thrive.
                    </p>
                  </div>
                </TabPanel>
                <TabPanel id="values" data-id="element-1117">
                  <div className="p-4 border border-gray-200 rounded-lg mt-4" data-id="element-1118">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1119">Core Values</h3>
                    <ul className="list-disc list-inside space-y-1" data-id="element-1120">
                      <li data-id="element-1121">Connection with Purpose</li>
                      <li data-id="element-1122">Opportunity for All</li>
                      <li data-id="element-1123">Community over Competition</li>
                      <li data-id="element-1124">Excellence and Impact</li>
                      <li data-id="element-1125">Global Mindset with Local Action</li>
                      <li data-id="element-1126">Trust and Respect</li>
                    </ul>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
          <div data-id="element-1127">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="Global community of professionals and changemakers" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1128" />
          </div>
        </div>
      </div>
    </div>;
};